// This file was automatically generated from appchart.visitNote.alertFeed.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.visitNote.alertFeed');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.visitNote.alertFeed.skeleton = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8CDSContainer"><h4 class="visit-note-cds-trigger el8HeaderNoBorder el8Thick"><span class="el8Wrap el8AttentionText"><span class="visit-note-cds-status el8Elt"></span>Clinical Reminders<div id="', soy.$$escapeHtml(opt_data.counterId), '" class="el8CDSCount el8InlineBlock"></div><a class="el8CDSSettingLink el8StandardLink visit-note-cds-settings-trigger" href="#">edit reminder settings</a></span></h4><ol id="', soy.$$escapeHtml(opt_data.listId), '"></ol></div>');
  if (!opt_sb) return output.toString();
};
